module.exports = __webpack_public_path__ + "img/index-top3.504dea50.png";